<div class="row col-sm-12 p-0 m-0 webview">
  <div
  [ngStyle]="{
    'display':
    IsOffSwitch ? 'none' : 'block'
  }"
  >

  
  <h3 class="plan-heading semi-bold lnhgt25"
  
  >
    Confirm Your Service Connection Type
  </h3>
  <p class="lnhgt16" *ngIf="swtprd">
    The Texas PUC passed a law allows you to select a future start date and
    still lock in today’s rate. You can select a switch date up to 14 days prior
    to your current contract’s expiration date without incurring an early
    termination penalty from your current energy provider.
  </p>
  <p class="lnhgt16">
    A move-in or switch can only be made by the electric service applicant or
    the applicant authorized agent.
  </p>
  <p>Please confirm which of the following you’d like to do:</p>
  <div class="d-flex mt-2">
    <div class="col-6 text-right">
      <label *ngIf="!IsOffSwitch"
        class="card card-list wd160 pt-2 text-center d-inline-block"
        for="SwitchingProviders"
      >
        <img src="{{ sp_src }}" height="100px" />
        <label
          for="SwitchingProviders"
          class="font-weight-normal-calibre font12"
          >Switching Providers</label
        >
        <div class="custom-control custom-checkbox boxchkbox chkbox mb-2">
          <input
            type="checkbox"
            class="custom-control-input"
            id="SwitchingProviders"
            (change)="getServiceType($event)"
            value="Switching Providers"
            [(ngModel)]="hgService.sp"
            name="service"
          />
          <label class="custom-control-label" for="SwitchingProviders"></label>
        </div>
      </label>
      <p *ngIf="!IsOffSwitch" class="lnhgt13 font13 float-right wd160 text-left">
        You currently have service in your name at this address
      </p>
    </div>
    <div class="col-6 text-left">
      <label
        class="card card-list wd160 pt-2 text-center d-inline-block"
        for="NewService"
      >
        <img src="{{ ns_src }}" height="100px" />
        <label for="NewService" class="font-weight-normal-calibre font12"
          >New Service</label
        >
        <div class="custom-control custom-checkbox boxchkbox chkbox mb-2">
          <input
            type="checkbox"
            class="custom-control-input"
            id="NewService"
            value="New Service"
            (change)="getServiceType($event)"
            [(ngModel)]="hgService.ns"
            name="service"
          />
          <label class="custom-control-label" for="NewService"></label>
        </div>
      </label>
      <p class="lnhgt13 font13 float-left wd160 text-left">
        There is no power at this address, or you are wanting to change the name
        on the account
      </p>
    </div>
  </div>
  <div class="col-12 chk-box px-0 ng-star-inserted" *ngIf="ShowConfirm">
  <h3 class="font20 text-left mt-2 mb-2 semi-bold">
    Choose Your Service Start Date
  </h3>
  </div>
  <p class="float-left w-100 lnhgt16" *ngIf="ShowConfirm">
    Depending on which service connection type you choose,
    <a href="javascript:void(0)" (click)="openModal(template)" class="btn-link"
      >certain fees may apply.</a
    >
    Please indicate when you would like to have your electricity service
    started.
  </p>
  <div class="chk-box" *ngIf="swtprd && ShowConfirm">
    <div
      class="custom-control d-inline-block custom-checkbox w-100 chkbox mt-0"
    >
      <input
        type="checkbox"
        class="custom-control-input"
        id="StandardSwitch"
        value="Standard Switch"
        [(ngModel)]="hgSwitch.switchValue1"
        name="typeOfSwitch"
        (change)="getSwitchDate($event)"
      />
      <label
        class="custom-control-label lnhgt16 font-weight-bold-calibre"
        for="StandardSwitch"
        >Standard Switch <br />
        <font class="font-weight-normal-calibre">3-7 business days</font>
      </label>
    </div>
    <div
      class="
        custom-control
        d-inline-block
        custom-checkbox
        w-100
        chkbox
        mt-0
        serviceoptdate
      "
    >
      <input
        type="checkbox"
        class="custom-control-input"
        id="SelfSelectedSwitch"
        value="Self-Selected Switch"
        [(ngModel)]="hgSwitch.switchValue2"
        name="typeOfSwitch"
        (change)="getSwitchDate($event)"
      />
      <label
        class="custom-control-label lnhgt16 font-weight-bold-calibre float-left"
        for="SelfSelectedSwitch"
        >Self-Selected Switch <br />
        <font class="font-weight-normal-calibre"
          >More than 7 business days in the future</font
        >
      </label>
    </div>
    <div
      _ngcontent-c5=""
      *ngIf="showDate && showdate_trigger"
      class="col-md-5 col-lg-4 mt-1 pl-0 float-left dateWidth"
      id="datepick"
    >
      <div class="form-group">
        <app-datepicker
          datepickerType="Self-Selected-Switch"
          [pickerPlaceholder]="placeholderText"
          [inputValue]="switchModel"
          (selectedItem)="selectedSwitchChanged($event)"
        ></app-datepicker>
        <!-- <mat-form-field class="example-full-width" appearance="fill">
          <mat-label>MM/DD/YYYY</mat-label>
          <input
            matInput
            [matDatepickerFilter]="myFilter"
            [matDatepicker]="picker"
            [min]="minDate"
            [max]="maxDate"
            [(ngModel)]="switchModel"
            (ngModelChange)="getDate()"
            required
            disabled
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker disabled="false"></mat-datepicker>
        </mat-form-field> -->
        <!-- <my-date-picker name="mydate" id="date" [(ngModel)]="switchModel" placeholder="MM/DD/YYYY" required></my-date-picker> -->
        <!-- <my-date-picker name="mydate" class="date-format" id ="date"
        [(ngModel)]="switchModel" (ngModelChange) = "getDate();" placeholder = "MM/DD/YYYY" required></my-date-picker> -->
        <!-- <my-date-picker
          name="mydate"
          type="date"
          [options]="myDatePickerOptions"
          [(ngModel)]="switchModel"
          (ngModelChange)="getDate()"
          placeholder="MM/DD/YYYY"
          required
        ></my-date-picker> -->
      </div>
    </div>
    <!-- </div> -->
  </div>
  </div>
  <div class="row col-sm-12 p-0 m-0 webview" *ngIf="ShowConfirm && IsOffSwitch">
  <p class="float-left w-100 lnhgt16" >
    Since you are one of the first to take advantage of this market opportunity, only move-ins are being processed by LPL through April 2024. Please confirm below.
   
  </p>
  </div>
  <div class="col-12 chk-box px-0" *ngIf="!swtprd && ShowConfirm">
    <div
      class="
        custom-control
        d-inline-block
        custom-checkbox
        w-100
        chkbox
        mt-0
        pt-0
      "
      
    >
      <input
        type="checkbox"
        class="custom-control-input"
        id="PriorityMoveIn"
        value="Priority Move-In"
        [(ngModel)]="hgNewService.newServiceValue1"
        name="typeOfNewService"
        (change)="getSwitchDate($event)"
      />
      <label class="custom-control-label lnhgt16 semi-bold" for="PriorityMoveIn"
        >{{ !IsOffSwitch ? "Priority Move-In" : "Standard Move-In"}} <br />
        <font class="font-weight-normal-calibre"
        [ngStyle]="{
          'display':
          IsOffSwitch ? 'none' : 'block'
        }"
          >If you need service within 24-48 business hours.</font
        >
        <font class="font-weight-normal-calibre"
        [ngStyle]="{
          'display':
          !IsOffSwitch ? 'none' : 'block'
        }"
          >LPL will set your billing cycle.</font
        >
      </label>
    </div>
    <div
      class="
        custom-control
       
        custom-checkbox
        w-100
        chkbox
        mt-0
        pt-0
        serviceoptdate
      "
      [ngStyle]="{
        'display':
        IsOffSwitch ? 'none' : 'block'
      }"
      
      [ngClass]="{ 'd-inline-block': !IsOffSwitch  }"
    >
      <input
        type="checkbox"
        class="custom-control-input"
        id="StandardMoveIn"
        value="Standard Move-In"
        [(ngModel)]="hgNewService.newServiceValue2"
        name="typeOfNewService"
        (change)="getSwitchDate($event)"
      />
      <label
        class="custom-control-label lnhgt16 semi-bold float-left"
        for="StandardMoveIn"
        >Standard Move-In <br />
        <font class="font-weight-normal-calibre"
          >At least 2 days after time of enrollment</font
        >
      </label>
    </div>
    <div
      _ngcontent-c5=""
      *ngIf="showDate && showdate_trigger"
      class="col-md-5 col-lg-4 mt-1 px-0 float-left dateWidth"
      id="datepick"
    >
      <div class="form-group">
        <app-datepicker
         datepickerType="StandardMoveIn"
          [pickerPlaceholder]="placeholderText"
          [inputValue]="model"
          (selectedItem)="valueChanged($event)"
        ></app-datepicker>
        <!-- <my-date-picker
          name="mydate"
          type="date"
          [options]="myDatePickerOptions"
          [(ngModel)]="model"
          (ngModelChange)="getDate()"
          placeholder="MM/DD/YYYY"
          required
        ></my-date-picker> -->
      </div>
    </div>
    <!-- <div class="col-md-12 d-flex flex-wrap">
        <div class="col-md-6 pl-0">
            <div class="custom-control d-inline-block custom-checkbox chkbox mt-0 pt-0 ">
                <input type="checkbox" class="custom-control-input" id="StandardMoveIn" value='Standard Move-In' [(ngModel)]="hgNewService.newServiceValue2"
                  name="typeOfNewService" (change)="getSwitchDate($event)">
                <label class="custom-control-label lnhgt16 semi-bold float-left" for="StandardMoveIn">Standard Move-In <br>
                  <font class="font-weight-normal-calibre">At least 2 days after time of enrollment</font>
                </label>
              </div>
        </div>
          <div class="col-md-6 mt-1">
              <div _ngcontent-c5="" *ngIf="showDate" class="col-md-12 mt-1 float-left dateWidth" id="datepick">
                  <div class="form-group">
                    <my-date-picker name="mydate" type="date" [options]="myDatePickerOptions" [(ngModel)]="model"
                    (ngModelChange)="getDate();" placeholder="MM/DD/YYYY" required></my-date-picker>
                  </div>
                </div>
          </div>
    </div> -->
  </div>

  <!-- <button _ngcontent-c14="" class=" float-left btn sectbtn signinpad mt-4 wd100" (click)="next('enrollment');">Next</button> -->
  <div class="col-sm-12 pl-0 webview" *ngIf="ShowConfirm">
    <button
      style="width: 150px !important"
      class="btn next mr-2 mt-2 font18 text-uppercase disabledButton"
      [disabled]="!btnEnable"
      [ngClass]="{ sectbtn: ngClass }"
      (click)="next('enrollment')"
    >
      Next
    </button>
  </div>
  <div class="mobileview text-center pl-1 mb-3">
    <!-- <button class="btn sectbtn col-sm-4 mt-2 mr-2 font18 text-uppercase" (click)="next('confirm');">Next</button> -->
    <a
    
      class="btn next mt-2 font18 text-uppercase"
      (click)="next('enrollment')"
      >Next</a
    >
  </div>
</div>
<div class="mobileview mt-3">
  <div class="d-flex h-100 row col-sm-12 p-0 m-0"
  >
    <div class="justify-content-center align-self-center col-sm-3 col-3 pl-0">
      <img style="width: 100%" src="assets/images/signimg.jpg" />
    </div>
    <div class="col-sm-9 col-9 px-0 my-auto">
      <div class="arrow_box">
        <h1 class="questionMob text-left"
        [ngStyle]="{
          'display':
          IsOffSwitch ? 'none' : 'block'
        }"
        >
          A move-in or switch can only be made by the electric service applicant
          or the applicant authorized agent. Confirm your service connection
          type
        </h1>
        <h1 class="questionMob text-left"
        [ngStyle]="{
          'display':
          !IsOffSwitch ? 'none' : 'block'
        }"
        >
        Since you are one of the first to take advantage of this market opportunity, only move-ins are being processed by LPL through April 2024. Please confirm below.
        </h1>
      </div>
    </div>
  </div>
  <div class="row col-sm-12 m-auto p-0 checks"
  [ngStyle]="{
    'display':
    IsOffSwitch ? 'none' : 'block'
  }"
  >
    <div class="d-flex mt-2">
      <div class="col-6 swtprvd text-right" [ngClass]="{ 'col-3': IsOffSwitch, 'col-6': !IsOffSwitch  }">
        <label *ngIf="!IsOffSwitch"
          class="card card-list wd140 pt-2 text-center d-inline-block"
          for="SwitchingProviders_mob"
        >
          <img src="{{ sp_src }}" height="80px" />
          <label for="SwitchingProviders_mob">Switching Providers</label>
          <div class="custom-control custom-checkbox boxchkbox chkbox mb-2">
            <input
              type="checkbox"
              class="custom-control-input"
              id="SwitchingProviders_mob"
              (change)="getServiceType($event)"
              value="Switching Providers"
              [(ngModel)]="hgService.sp"
              name="service"
            />
            <label
              class="custom-control-label"
              for="SwitchingProviders_mob"
            ></label>
          </div>
        </label>
        <p *ngIf="!IsOffSwitch" class="lnhgt16 font15 float-right wd140 text-left">
          You currently have service in your name at this address
        </p>
      </div>
      <div class="col-6 newsrv text-left">
        <label
          class="card card-list wd140 pt-2 text-center d-inline-block"
          for="NewService_mob"
        >
          <img src="{{ ns_src }}" height="80px" />
          <label for="NewService_mob">New Service</label>
          <div class="custom-control custom-checkbox boxchkbox chkbox mb-2">
            <input
              type="checkbox"
              class="custom-control-input"
              id="NewService_mob"
              value="New Service"
              (change)="getServiceType($event)"
              [(ngModel)]="hgService.ns"
              name="service"
            />
            <label class="custom-control-label" for="NewService_mob"></label>
          </div>
        </label>
        <p class="lnhgt16 font15 float-left wd140 text-left">
          There is no power at this address, or you are wanting to change the
          name on the account
        </p>
      </div>
    </div>
    <p *ngIf="ShowConfirm" class="w-100 text-center semi-bold lnhgt20">
      You are choosing “{{ serviceType }}” <br /><a
        href="javascript:void(0)"
        data-toggle="modal"
        data-target="#seeDetailModal"
        class="btn-link"
        >See details</a
      >
    </p>
  </div>
  <div class="row" *ngIf="ShowConfirm"
  [ngStyle]="{
    'display':
    IsOffSwitch ? 'none' : 'block'
  }"
  >
    <div class="col-12 d-flex h-100">
      <div class="justify-content-center align-self-center col-sm-3 col-3 pl-0">
        <img style="width: 100%" src="assets/images/signimg.jpg" />
      </div>
      <div class="col-sm-9 col-9 px-0 my-auto">
        <div class="arrow_box">
          <h1 class="questionMob text-left">Confirm your service start date</h1>
        </div>
      </div>
    </div>
    <p class="lnhgt16 font15 col text-left">
      Depending on which service connection type you choose,
      <a
        href="javascript:void(0)"
        (click)="openModal(template)"
        class="btn-link"
        >certain fees may apply.</a
      >
      Please indicate when you would like to have your electricity service
      started.
    </p>
  </div>
  <div class="chk-box" *ngIf="swtprd && ShowConfirm"
  [ngStyle]="{
    'display':
    IsOffSwitch ? 'none' : 'block'
  }"
  >
    <div class="card card-list pt-2 mt-1 text-left w-100 d-inline-block">
      <div
        class="
          custom-control
          d-inline-block
          w-100
          pl-5
          chkbox
          custom-checkbox
          mt-0
        "
      >
        <input
          type="checkbox"
          class="custom-control-input"
          id="StandardSwitch"
          value="Standard Switch"
          [(ngModel)]="hgSwitch.switchValue1"
          name="typeOfSwitch"
          (change)="getSwitchDate($event)"
        />
        <label
          id="button12345"
          class="
            custom-control-label
            lnhgt16
            font-weight-bold-calibre
            mob-ml-40
          "
          for="StandardSwitch"
          >Standard Switch <br />
          <font class="font-weight-normal-calibre">3-7 business days</font>
        </label>
      </div>
    </div>
    <div class="card card-list pt-2 mt-1 text-left w-100 d-inline-block">
      <div
        class="
          custom-control
          d-inline-block
          w-100
          pl-5
          chkbox
          custom-checkbox
          mt-0
        "
      >
        <input
          type="checkbox"
          class="custom-control-input"
          id="SelfSelectedSwitch"
          value="Self-Selected Switch"
          [(ngModel)]="hgSwitch.switchValue2"
          name="typeOfSwitch"
          (change)="getSwitchDate($event)"
        />
        <label
          class="
            custom-control-label
            lnhgt16
            font-weight-bold-calibre
            float-left
            mob-ml-40
          "
          for="SelfSelectedSwitch"
          >Self-Selected Switch <br />
          <font class="font-weight-normal-calibre"
            >More than 7 business days in the future</font
          >
        </label>
        <div
          _ngcontent-c5=""
          *ngIf="showDate"
          class="col-md-5 col-lg-4 mt-1 pl-0 float-left"
          id="datepick"
        >
          <div class="form-group mb-0 ml-2">
            <app-datepicker
             datepickerType="Self-Selected-Switch"
              [pickerPlaceholder]="placeholderText"
              [inputValue]="switchModel"
              (selectedItem)="selectedSwitchChanged($event)"
            ></app-datepicker>
            <!-- <my-date-picker name="mydate" id="date" [(ngModel)]="switchModel" placeholder="MM/DD/YYYY" required></my-date-picker> -->
            <!-- <my-date-picker name="mydate" class="date-format" id ="date"
                    [(ngModel)]="switchModel" (ngModelChange) = "getDate();" placeholder = "MM/DD/YYYY" required></my-date-picker> -->
            <!-- <mat-form-field class="example-full-width" appearance="fill">
              <mat-label>MM/DD/YYYY</mat-label>
              <input
                matInput
                [matDatepickerFilter]="myFilter"
                [matDatepicker]="mobpicker1"
                [min]="minDate"
                [max]="maxDate"
                [(ngModel)]="switchModel"
                (ngModelChange)="getDate()"
                required
                readonly
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="mobpicker1"
              ></mat-datepicker-toggle>
              <mat-datepicker #mobpicker1></mat-datepicker>
            </mat-form-field> -->
            <!-- <my-date-picker
              name="mydate"
              type="date"
              [options]="myDatePickerOptions"
              [(ngModel)]="switchModel"
              (ngModelChange)="getDate()"
              placeholder="MM/DD/YYYY"
              required
            ></my-date-picker> -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="chk-box my-2" *ngIf="!swtprd && ShowConfirm">
    <div
      class="
        card card-list
        pt-2
        mt-1
        text-left
        w-100
        d-inline-block
        border-none
        shadow-none
        mb-3
      "
    >
      <div
        class="
          custom-control
          d-inline-block
          w-100
          pl-5
          chkbox
          custom-checkbox
          mt-0
        "
        style="margin-bottom: 0px !important"
      >
        <input
          type="checkbox"
          class="custom-control-input"
          id="PriorityMoveIn"
          value="Priority Move-In"
          [(ngModel)]="hgNewService.newServiceValue1"
          name="typeOfNewService"
          (change)="getSwitchDate($event)"
        />
        <label id="button12346"
          class="custom-control-label lnhgt16 font-weight-bold-calibre pt-1"
          for="PriorityMoveIn"
          >{{ !IsOffSwitch ? "Priority Move-In" : "Standard Move-In"}} <br />
          <font class="font-weight-normal-calibre"
          [ngStyle]="{
            'display':
            IsOffSwitch ? 'none' : 'block'
          }"
            >If you need service within 24-48 business hours.</font
          >
          <font class="font-weight-normal-calibre"
          [ngStyle]="{
            'display':
            !IsOffSwitch ? 'none' : 'block'
          }"
          >LPL will set your billing cycle.</font
        >
        </label>
      </div>
    </div>
    <div
      class="
        card card-list
        pt-2
        text-left
        w-100
        
        border-none
        shadow-none
      "
      [ngStyle]="{
        'display':
        IsOffSwitch ? 'none' : 'block'
      }"
      
      [ngClass]="{ 'd-inline-block': !IsOffSwitch  }"
    >
      <div
        class="
          custom-control
          d-inline-block
          w-100
          pl-5
          chkbox
          custom-checkbox
          mt-0
        "
        style="margin-bottom: 0px !important"
      >
        <input
          type="checkbox"
          class="custom-control-input"
          id="StandardMoveIn"
          value="Standard Move-In"
          [(ngModel)]="hgNewService.newServiceValue2"
          name="typeOfNewService"
          (change)="getSwitchDate($event)"
        />
        <label
          class="
            custom-control-label
            lnhgt16
            font-weight-bold-calibre
            float-left
            pt-1
          "
          id="button12345"
          for="StandardMoveIn"
          >Standard Move-In
          <br />
          <font class="font-weight-normal-calibre"
            >At least 2 days after time of enrollment</font
          >
        </label>
        <div
          _ngcontent-c5=""
          class="col-md-5 col-lg-4 mt-1 pl-0 float-left"
          id="datepick"
          *ngIf="showDate"
        >
          <div class="col-12 form-group mb-0">
            <app-datepicker
              datepickerType="StandardMoveIn"
              [pickerPlaceholder]="placeholderText"
              [inputValue]="model"
              (selectedItem)="valueChanged($event)"
            ></app-datepicker>

            <!-- <mat-form-field class="example-full-width" appearance="fill">
              <mat-label>MM/DD/YYYY</mat-label>
              <input
                matInput
                [matDatepickerFilter]="myFilter"
                [matDatepicker]="mobpicker2"
                [min]="minDate"
                [max]="maxDate"
                [(ngModel)]="model"
                (ngModelChange)="getDate()"
                required
                readonly
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="mobpicker2"
              ></mat-datepicker-toggle>
              <mat-datepicker #mobpicker2></mat-datepicker>
            </mat-form-field> -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-3" *ngIf="ShowConfirm">
    <div class="col-12 text-center">
      <!-- <button href="#enrollSection" class="btn sectbtn mt-2 font18 text-uppercase" [disabled]="!btnEnable" (click)="next('enrollment');">Next</button> -->
      <a
        
        [ngClass]="{ isDisabled: !btnEnable, sectbtn: ngClass }"
        class="btn next mt-2 font18 text-uppercase disabledButton"
        (click)="next('enrollment')"
        >Next</a
      >
    </div>
  </div>
  <br />
</div>
<!--To load the enrollment section for mobile view-->
<div
  class="mobileview"
  id="enrollSection"
  style="top: 0px"
  *ngIf="showEnrollmentComp"
>
  <app-enrollment [esiid_value]="esiid_value"></app-enrollment>
</div>
<div
  class="modal fade"
  data-backdrop="static"
  data-keyboard="false"
  id="seeDetailModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog wd90" role="document">
    <div class="modal-content">
      <div class="modal-body lnhgt16 font-weight-normal-calibre">
        <button type="button" class="close popclose" data-dismiss="modal">
          <img src="assets/images/editchart-close.svg" width="17" />
        </button>
        <h4 class="modal-title">Connection Type Details</h4>
        <hr class="hrline" />
        <p class="font15" *ngIf="swtprd">
          The Texas PUC passed a law allows you to select a future start date
          and still lock in today’s rate. You can select a switch date up to 14
          days prior to your current contract’s expiration date without
          incurring an early termination penalty from your current energy
          provider.
        </p>
        <p class="font15" *ngIf="!swtprd">
          A move-in or switch can only be made by the electric service applicant
          or the applicant authorized agent.
        </p>
      </div>
    </div>
  </div>
</div>
<ng-template #template>
  <div class="modal-header py-0">
    <div class="col-12 text-right py-0 px-0 modal-border">
      <button
        type="button"
        class="close pull-right borderNone closeModelAlign"
        aria-label="Close"
        (click)="modalRef.hide()"
      >
        <div _ngcontent-c5="" class="float-right mt-1">
          <img src="assets/images/editchart-close.svg" width="17" />
        </div>
      </button>
      <br />
      <h4 class="modal-title pull-left semi-bold font20">
        Move In and Switch Fees by Utility
      </h4>
    </div>
  </div>
  <div class="modal-body">
    <p class="font15 linehgt">
      This fee schedule reflects what you could be charged from your local
      Utility to start new service or switch providers. These prices are subject
      to change. Please check with your respective Utility for the
      most-up-to-date pricing.
    </p>
    <div class="row col-sm-12 pb-2">
      <div class="col-md-6 col-6 pl-0">
        <p class="font15 calibre-semibold mb-0">New Service</p>
        <p class="font15 font-weight-normal-calibre">
          <span>Standard Move In</span><br />
          <span class="calibre-italic"
            >At least 2 days after time of enrollment</span
          >
        </p>
        <br />
        <p class="font15 font-weight-normal-calibre">
          <span>Priority Move In</span><br />
          <span class="calibre-italic"
            >Power needs to be turned on within 24-48 hours</span
          >
        </p>
      </div>
      <div class="col-md-6 col-6">
        <p class="font15 calibre-semibold mb-0">Switching Providers</p>
        <p class="font15 font-weight-normal-calibre">
          <span>Standard Switch</span><br />
          <span class="calibre-italic">3-7 Business Days after enrollment</span>
        </p>
        <br />
        <p class="font15 font-weight-normal-calibre">
          <span>Self-Select Switch</span><br />
          <span class="calibre-italic"
            >More than 7 business days in the future</span
          >
        </p>
      </div>
    </div>
    <div class="rounded webview">
      <table class="table">
        <thead>
          <tr>
            <th scope="col" class="font15 semi-bold text-center">TDSP</th>
            <th scope="col" class="font15 semi-bold text-center">Move In</th>
            <th scope="col" class="font15 semi-bold text-center">
              Priority Move In
            </th>
            <th scope="col" class="font15 semi-bold text-center">
              Self-Select Switch
            </th>
            <th scope="col" class="font15 semi-bold text-center last">
              Standard Switch<br />(3 - 7 Business Days)
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let element of tduRates; let i = index">
            <td class="font15 font-weight-normal-calibre text-center">
              {{ loadActualUtilityName[element.Abbreviation] }}
            </td>
            <td class="font15 font-weight-normal-calibre text-center">
              ${{ checkForWholeOrDecimal(element.MoveInFee) }}
            </td>
            <td class="font15 font-weight-normal-calibre text-center">
              ${{ checkForWholeOrDecimal(element.PriorityMoveInFee) }}
            </td>
            <td class="font15 font-weight-normal-calibre text-center">
              ${{ checkForWholeOrDecimal(element.SwitchFee) }}
            </td>
            <td class="font15 font-weight-normal-calibre text-center">$0.00</td>
          </tr>
        </tbody>
        <!-- <tbody>
          <tr>
            <td class="font15 font-weight-normal-calibre text-center">
              AEP Central
            </td>
            <td class="font15 font-weight-normal-calibre text-center">$6.00</td>
            <td class="font15 font-weight-normal-calibre text-center">
              $13.00
            </td>
            <td class="font15 font-weight-normal-calibre text-center">$3.00</td>
            <td class="font15 font-weight-normal-calibre text-center">$0.00</td>
          </tr>
          <tr>
            <td class="font15 font-weight-normal-calibre text-center">
              AEP North - WTU
            </td>
            <td class="font15 font-weight-normal-calibre text-center">$2.00</td>
            <td class="font15 font-weight-normal-calibre text-center">$7.00</td>
            <td class="font15 font-weight-normal-calibre text-center">$1.00</td>
            <td class="font15 font-weight-normal-calibre text-center">$0.00</td>
          </tr>
          <tr>
            <td class="font15 font-weight-normal-calibre text-center">
              Centerpoint
            </td>
            <td class="font15 font-weight-normal-calibre text-center">$0.00</td>
            <td class="font15 font-weight-normal-calibre text-center">$0.00</td>
            <td class="font15 font-weight-normal-calibre text-center">$0.00</td>
            <td class="font15 font-weight-normal-calibre text-center">$0.00</td>
          </tr>
          <tr>
            <td class="font15 font-weight-normal-calibre text-center">Oncor</td>
            <td class="font15 font-weight-normal-calibre text-center">$3.20</td>
            <td class="font15 font-weight-normal-calibre text-center">
              $10.35
            </td>
            <td class="font15 font-weight-normal-calibre text-center">$1.90</td>
            <td class="font15 font-weight-normal-calibre text-center">$0.00</td>
          </tr>
          <tr>
            <td class="font15 font-weight-normal-calibre text-center">
              Sharyland McAllen
            </td>
            <td class="font15 font-weight-normal-calibre text-center">
              $21.00
            </td>
            <td class="font15 font-weight-normal-calibre text-center">
              $51.00
            </td>
            <td class="font15 font-weight-normal-calibre text-center">$7.00</td>
            <td class="font15 font-weight-normal-calibre text-center">$0.00</td>
          </tr>
          <tr>
            <td class="font15 font-weight-normal-calibre text-center">TNMP</td>
            <td class="font15 font-weight-normal-calibre text-center">
              $54.00
            </td>
            <td class="font15 font-weight-normal-calibre text-center">
              $79.00
            </td>
            <td class="font15 font-weight-normal-calibre text-center">
              $27.00
            </td>
            <td class="font15 font-weight-normal-calibre text-center">$0.00</td>
          </tr>
          <tr>
            <td class="font15 font-weight-normal-calibre text-center">
              Sharyland Utility
            </td>
            <td class="font15 font-weight-normal-calibre text-center">
              $49.80
            </td>
            <td class="font15 font-weight-normal-calibre text-center">
              $79.27
            </td>
            <td class="font15 font-weight-normal-calibre text-center">
              $25.13
            </td>
            <td class="font15 font-weight-normal-calibre text-center">$0.00</td>
          </tr>
        </tbody> -->
      </table>
    </div>
    <div
      class="rounded mobileview text-center"
      style="float: left; width: 100%"
    >
      <div style="float: left; width: 50%">
        <table class="table" style="display: inline-block">
          <thead>
            <tr>
              <th scope="col" class="font15 semi-bold text-center">TDSP</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="font15 font-weight-normal-calibre text-center">
                AEP Central
              </td>
            </tr>
            <tr>
              <td class="font15 font-weight-normal-calibre text-center">
                AEP North
              </td>
            </tr>
            <tr>
              <td class="font15 font-weight-normal-calibre text-center">
                Centerpoint
              </td>
            </tr>
            <tr>
              <td class="font15 font-weight-normal-calibre text-center">NEC</td>
            </tr>
            <tr>
              <td class="font15 font-weight-normal-calibre text-center">
                Oncor
              </td>
            </tr>
            <tr>
              <td class="font15 font-weight-normal-calibre text-center">
                Sharyland Utility
              </td>
            </tr>
            <tr>
              <td class="font15 font-weight-normal-calibre text-center">
                TNMP
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div style="float: left; width: 50%">
        <table class="table" style="display: inline-block">
          <thead
            style="height: 70px !important; vertical-align: middle !important"
          >
            <tr class="p-0">
              <th scope="col" class="font15 semi-bold text-center last">
                <a (click)="prevTab()" class="pull-left" *ngIf="tableIndex != 0"
                  ><img src="assets/images/left-arrow.png"
                /></a>
                {{ tableElements[tableIndex].thead }}
                <a
                  (click)="nextTab()"
                  class="pull-right"
                  *ngIf="tableIndex != 3"
                  ><img src="assets/images/right-arrow.png"
                /></a>
                <!-- <p class="mb-0 text-center" *ngIf="tableIndex == 2">Switch</p> -->
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let element of rowElements; let i = index">
              <td class="font15 font-weight-normal-calibre text-center last">
                {{ element }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #newEnergyRates>
  <div id="serviceunavialbe">
    <div class="modal-header pr-1 pt-1">
      <div class="col-12 text-right py-0 px-0">
        <button
          type="button"
          class="close pull-right borderNone closeModelAlign"
          aria-label="Close"
          (click)="newEnergyProviderRates()"
        >
          <div _ngcontent-c5="" class="float-right mr-1 mt-1">
            <img src="assets/images/editchart-close.svg" width="17" />
          </div>
        </button>
      </div>
    </div>
    <div class="modal-body pt-0">
      <h4 class="utility-modal-title font20 text-center text-uppercase">
        THESE OFFERS HAVE EXPIRED
      </h4>
      <p class="utility-sub-title font20">
        PRICE FLASH! Due to market volatility, this price is no longer being
        offered by the energy provider you have selected. However, this update
        could possibly work in your favor!
      </p>
      <br />
      <p class="utility-sub-title font20">
        Click the button below 👇 to see new rates.
      </p>
      <br />
      <p class="utility-sub-title font20">
        We appreciate your patience, and apologize In advance for any
        inconvenience, while we update our records. This may take a few seconds.
      </p>
      <div class="col-12 text-center">
        <button
          class="
            btn
            mr-2
            ml-2
            col-12
            font-weight-bold-calibre
            contbtn
            text-uppercase
            mb-3
          "
          (click)="newEnergyProviderRates()"
        >
          see new rates
        </button>
      </div>
    </div>
  </div>
</ng-template>
